<button
  [bitAction]="download"
  bitIconButton="bwi-download"
  buttonType="main"
  size="small"
  type="button"
  [appA11yTitle]="'downloadAttachmentName' | i18n: attachment.fileName"
></button>
